import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { Hero } from '../components/vsl/Hero';
import { PainSection } from '../components/vsl/PainSection';
import { MethodSection } from '../components/vsl/MethodSection';
import { ModulesSection } from '../components/vsl/ModulesSection';
import { BonusSection } from '../components/vsl/BonusSection';
import { TestimonialsSection } from '../components/vsl/TestimonialsSection';
import { OfferSection } from '../components/vsl/OfferSection';
import { FaqSection } from '../components/vsl/FaqSection';
import { StickyCta } from '../components/vsl/StickyCta';
import { SiteFooter } from '../components/vsl/SiteFooter';
import { PixelDebugPanel } from '../components/vsl/PixelDebugPanel';
type CurlySeduccionProps = {
  showTestimonials: boolean;
  showStickyCta: boolean;
  debugPixel: boolean;
};
export function CurlySeduccion({
  showTestimonials,
  showStickyCta,
  debugPixel
}: CurlySeduccionProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink font-sans" data-id="element-162" data-mp="gh2ft691nf82">
      <Hero data-id="element-163" data-mp="gidif2qr6gxl" />
      <main data-id="element-164" data-mp="lf46ac8sugtk">
        <PainSection data-id="element-165" data-mp="lfm2j8vgov1h" />
        <MethodSection data-id="element-166" data-mp="le2lhg1zefyn" />
        <ModulesSection data-id="element-167" data-mp="leaxl5qa5h8s" />
        <BonusSection data-id="element-168" data-mp="lgx8nfcdqevr" />
        {showTestimonials && <TestimonialsSection data-id="element-169" data-mp="6p6hbu31pn3b" />}
        <OfferSection data-id="element-170" data-mp="6py2sc2xi4fv" />
        <FaqSection data-id="element-171" data-mp="bpay7l7v8ju2" />
      </main>
      <SiteFooter data-id="element-172" data-mp="boj46etx2u5w" />
      {showStickyCta && <StickyCta data-id="element-173" data-mp="bnge294f4vr1" />}
      {debugPixel && <PixelDebugPanel data-id="element-174" data-mp="3tv5rhvp3nraq" />}
    </div>;
}